import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as data from '../../config/config.json';
//import * as data from '../../config/config_stage.json';


@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private settings: any;
  private http: HttpClient;
  constructor(private readonly httpHandler: HttpBackend) {
    this.http = new HttpClient(httpHandler);
  }

  load(): Promise<boolean> {
    let endpoint = "config/config.json";
    return new Promise<boolean>((resolve, reject) => {
      this.settings = data;
      //console.log(data);
      resolve(true);
      // this.http.get(endpoint).pipe(map(res => res))
      //   .subscribe(value => {
      //     this.settings = value;
      //     resolve(true);
      //   },
      //   (error) => {
      //     reject(error);
      //   });
    });
  }

  getSettings(key?: string | Array<string>): any {
    if (!key || (Array.isArray(key) && !key[0])) {
      return this.settings;
    }

    if (!Array.isArray(key)) {
      key = key.split('.');
    }

    let result = key.reduce((acc: any, current: string) => acc && acc[current], this.settings["default"]);

    return result;
  }
}